module.exports = __webpack_public_path__ + "assets/06231fecb6aa2a12e5a8762c3f755308.png";